export default __webpack_public_path__ + "static/media/Before-Hot-Mop-.3be93fb3.jpg";